import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full border-b border-line bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="testimonios-title" data-id="element-257" data-mp="1mzsai10nhef7">
      <div className="mx-auto max-w-5xl" data-id="element-258" data-mp="1d24df4fknutv">
        <SectionHeading eyebrow="❤️" title="Más clientes que ya transformaron" data-id="element-259" data-mp="1d1300tb32w8z" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-260" data-mp="1i1z5hbb32qgi">
          {testimonials.map((item, index) => <motion.li key={item.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-line bg-surface p-6" data-id="element-261" data-mp="1427u7ibybo67" data-mpi={index}>
              <figure data-id="element-262" data-mp="2q2hll0fnbxm7">
                <div className="flex items-start gap-3" data-id="element-263" data-mp="2q3152lky2u2c">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold/15 text-sm font-extrabold text-gold" data-id="element-264" data-mp="2q0ewcimbi8ij">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-265" data-mp="2zunc05q926za">
                    <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-266" data-mp="2c1x54ax7edvv">
                      {Array.from({
                    length: 5
                  }).map((_, starIndex) => <StarIcon key={starIndex} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-267" data-mp="275zxqu3x4hv8" data-mpi={starIndex} />)}
                    </div>
                    <figcaption className="mt-1 text-sm font-bold text-white" data-id="element-268" data-mp="1940q95yload">
                      {item.name}
                    </figcaption>
                    <p className="mt-0.5 flex flex-wrap items-center gap-1.5 text-xs text-neutral-500" data-id="element-269" data-mp="3f0w1ox7c4y2">
                      <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-270" data-mp="8dlmiwmnja9b" />
                      {item.location}
                      {item.tag ? <span data-id="element-271" data-mp="ddzuyfs60m7v">| {item.tag}</span> : null}
                    </p>
                  </div>
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-272" data-mp="ibjark4ih71x">
                  “{item.quote}”
                </blockquote>
              </figure>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}